/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterInfosDto } from '../../models/mitarbeiter-infos-dto';

export interface GetAllMitarbeiterRangeAggregated$Json$Params {
  Units?: Array<string>;
  Kostenstelle?: string;
  TarifAttribut?: string;
  AttributId?: string;
  Start: string;
  Ende: string;
}

export function getAllMitarbeiterRangeAggregated$Json(http: HttpClient, rootUrl: string, params: GetAllMitarbeiterRangeAggregated$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterInfosDto>> {
  const rb = new RequestBuilder(rootUrl, getAllMitarbeiterRangeAggregated$Json.PATH, 'get');
  if (params) {
    rb.query('Units', params.Units, {});
    rb.query('Kostenstelle', params.Kostenstelle, {});
    rb.query('TarifAttribut', params.TarifAttribut, {});
    rb.query('AttributId', params.AttributId, {});
    rb.query('Start', params.Start, {});
    rb.query('Ende', params.Ende, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterInfosDto>;
    })
  );
}

getAllMitarbeiterRangeAggregated$Json.PATH = '/v1/mitarbeiter/aggregated/range';
